import React, { useEffect } from 'react';
import styled from 'styled-components';
import facebookImage from '../images/facebook.svg';
import twitterImage from '../images/twitter.svg';
import pinterestImage from '../images/pinterest.svg';
import mailImage from '../images/mail.svg';
import Constants from '../../../constants/Articles';
import { loadScript } from '../utils';
import { EventCategories, EventActions } from '../../../constants/Analytics';

export const SocialBar = styled.div`
  position: -webkit-sticky;
  position: sticky;
  background: #ff7300;
  top: 0px;
  background-color: #fff;
  width: 35px;
  .st-custom-button[data-network] {
    padding: 5px;
    width: 35px;
    img {
      cursor: pointer;
    }
  }
`;

const SocialShareBar = () => {
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    // fix sharethis data cache issue when routing changes
    if ((window as any).__sharethis__) {
      (window as any).__sharethis__ = {};
    }
    loadScript(Constants.SHARE_THIS_URL);
  }, []);

  return (
    <SocialBar>
      <div
        data-network="facebook"
        className="st-custom-button"
        data-ga-category={EventCategories.ARTICLES}
        data-ga-action={EventActions.SOCIAL_SHARE_BAR_CLICK_ICONS}
        data-ga-label="[Facebook]"
      >
        <img src={facebookImage} />
      </div>
      <div
        data-network="twitter"
        className="st-custom-button"
        data-ga-category={EventCategories.ARTICLES}
        data-ga-action={EventActions.SOCIAL_SHARE_BAR_CLICK_ICONS}
        data-ga-label="[Twitter]"
      >
        <img src={twitterImage} />
      </div>
      <div
        data-network="pinterest"
        className="st-custom-button"
        data-ga-category={EventCategories.ARTICLES}
        data-ga-action={EventActions.SOCIAL_SHARE_BAR_CLICK_ICONS}
        data-ga-label="[Pinterest]"
      >
        <img src={pinterestImage} />
      </div>
      <div
        data-network="email"
        className="st-custom-button"
        data-ga-category={EventCategories.ARTICLES}
        data-ga-action={EventActions.SOCIAL_SHARE_BAR_CLICK_ICONS}
        data-ga-label="[Email]"
      >
        <img src={mailImage} />
      </div>
    </SocialBar>
  );
};

export default SocialShareBar;
